var _defs, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Cross",
    "data-name": "Icon/Cross",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M12.293,13.707,7,8.414,1.707,13.707A1,1,0,0,1,.292,12.293L5.585,7,.292,1.707A1,1,0,0,1,1.707.292L7,5.585,12.293.292a1,1,0,1,1,1.414,1.415L8.414,7l5.293,5.293a1,1,0,1,1-1.414,1.414Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Grid",
    d: "M0,0H30V30H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M12.293,13.707,7,8.414,1.707,13.707A1,1,0,0,1,.292,12.293L5.585,7,.292,1.707A1,1,0,0,1,1.707.292L7,5.585,12.293.292a1,1,0,1,1,1.414,1.415L8.414,7l5.293,5.293a1,1,0,1,1-1.414,1.414Z",
    transform: "translate(8 8)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Cross-2",
    "data-name": "Icon/Cross",
    transform: "translate(8 8)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_Fill_Dark",
    "data-name": "Icon/\\uD83D\\uDD8C Fill/Dark",
    d: "M0,0H30V30H0Z",
    transform: "translate(-8 -8)",
    fill: "#2c2738"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/Icon-Cross.2719b1ac38d1bd54465e03fcb298ab45.svg";
export { ForwardRef as ReactComponent };